export const SET_MENU_STATE = 'SET_MENU_STATE';
